import { MouseEvent, useId } from "react";
import { mergeRefs } from "react-merge-refs";
import { useDraggable } from "@dnd-kit/core";
import { useBottomSheetToggle } from "../BottomSheet.Parts";
import { Container, Props } from "./DragTapSurface.Parts";

// Extends the sheet's drag-and-tap surface to cover custom content — e.g. the
// whole bar of a collapsed mini player, or a wider strip at the top of an
// expanded sheet. Must be rendered inside a BottomSheet
export const DragTapSurface = ({
  children,
  ref,
  onClick,
  id,
  ...props
}: Props) => {
  const generatedId = useId();
  // An explicit id makes multiple simultaneous drag surfaces easier to tell
  // apart in dnd-kit's active.id while debugging; used for both the DOM id
  // and dnd-kit's id so they stay in sync
  const resolvedId = id ?? generatedId;
  const { setNodeRef, listeners, attributes } = useDraggable({
    id: resolvedId,
  });
  const toggleSnapPoint = useBottomSheetToggle();

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    // Otherwise tapping a button would also toggle the sheet
    if ((event.target as HTMLElement).closest("button")) return;
    toggleSnapPoint();
    onClick?.(event);
  };

  return (
    <Container
      id={resolvedId}
      ref={mergeRefs([setNodeRef, ref])}
      onClick={handleClick}
      {...listeners}
      {...attributes}
      {...props}
    >
      {children}
    </Container>
  );
};
